var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 126.258,
    viewBox: "0 0 256 126.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_6",
    "data-name": "Ret\\xE2ngulo 6",
    width: 256,
    height: 126.258,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M13.314,183.039c0,5.461,1.976,7.541,5.357,8.477l-.052.416c-3.189,0-7.271.383-9.139.093-.066-.01.066-.009,0,0-2.986.416-6.29-.093-9.428-.093L0,191.517c3.329-.936,5.357-3.017,5.357-8.477V164.732c0-5.565-1.716-7.541-4.941-8.426l.052-.312a57.476,57.476,0,0,1,8.8.817c.064.01.226.057.192,0s13.381-.513,14.519-1.7h.416c-.052,3.016-.676,6.969-.728,9.726a.689.689,0,0,1-.663-.508c-.858-3.13-1.106-5.474-5.994-5.474-3.485,0-3.693.78-3.693,4.629v8.206a.688.688,0,0,0,.688.688h.925a5.2,5.2,0,0,0,4.959-2.259.68.68,0,0,1,.56-.289h.1c-.052,3.485-.728,6.917-.728,9.622h-.364c-.824-2.936-2.158-4.342-3.953-4.57a.839.839,0,0,0-.1-.006H14a.687.687,0,0,0-.688.688Z",
    transform: "translate(0 -117.849)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M288.449,188.034c-9.1,0-15.031-7.074-15.031-17.475s5.981-18.879,15.863-18.879c9.05,0,15.031,7.073,15.031,17.475s-6.033,18.88-15.863,18.88m.3-31.475c-4.473,0-6.074,4.326-6.074,12.336,0,11.806,2.622,13.849,6.314,13.849,4.525,0,6.012-3.967,6.012-11.924,0-11.7-2.507-14.26-6.252-14.26",
    transform: "translate(-207.737 -115.242)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M423.365,173.4c1.5-1.127,8.278-7,8.278-11.163,0-4.629-4.307-7.335-7.479-7.335a2.217,2.217,0,0,0-.936.208v24.913c0,5.461,2.028,7.541,5.409,8.478l-.052.416c-.806,0-1.6-.039-2.39-.1a84.884,84.884,0,0,0-13.874,0c-.762.062-1.53.1-2.3.1l-.052-.416c3.329-.936,5.305-3.017,5.305-8.478V162.7c0-6.189-1.924-8.373-5.461-9.362l.052-.364c.9.031,1.8.082,2.7.148a67.472,67.472,0,0,0,10.551-.06c.719-.06,1.464-.089,2.3-.089,9.258,0,12.014,3.589,12.014,8.114,0,4.213-3.016,7.749-7.541,9.309,4,.572,6.293,3.953,7.905,7.021,2.392,4.629,4.317,9.466,7.541,9.466a2.525,2.525,0,0,0,1.768-.624l.208.416c-2.9,3.351-4.473,2.548-7.594,2.548-4.577,0-7.541-2.756-9.829-8.894-1.664-4.421-6.52-6.935-6.52-6.935",
    transform: "translate(-311.363 -116.228)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M718.558,154.062c.624,0,.364,10.818.364,10.818s-.346.026-.416-.052c-3.549-3.943-3.849-9.517-7.333-9.517a3.8,3.8,0,0,0-3.953,3.953c0,3.173,2.861,4.681,7.541,7.437,4.473,2.6,7.489,5.825,7.489,10.818,0,6.293-4.993,11.442-13.054,11.442-2.5,0-9.05-.52-8.841-4.733,0,0,.895-10.96.988-10.87C707.23,179.024,706.18,186,710.184,186c2.652,0,5.357-1.612,5.357-5.2,0-3.433-2.5-4.941-5.253-6.449-5.513-3.016-9.674-5.409-9.674-11.442,0-7.073,5.929-10.142,11.234-10.142,4.264,0,5.3,1.3,6.709,1.3",
    transform: "translate(-532.109 -116.065)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M818.781,169.006c0,11.806,3.381,16.279,7.957,16.279,3.589,0,4.718-5.7,8.79-9.258.088-.077.468,0,.468,0l-.572,7.8c-.312,3.849-4.993,4.264-9,4.264-10.609,0-17.111-7.021-17.111-17.423s6.917-18.775,16.8-18.775c4.733,0,6.813,1.3,8.166,1.3a1.863,1.863,0,0,0,1.976-1.3S837.281,162.95,834.7,165c-.092.073-.468-.052-.468-.052-.364-6.4-4.421-10.662-8.737-10.662-5.045,0-6.709,6.241-6.709,14.719",
    transform: "translate(-614.898 -115.406)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M944.626,177.262c-1.745-1.271-6.991-1.4-8.634,0-.651.555-1.144.971-1.144.971a10.967,10.967,0,0,0-.78,3.485c0,1.924,1.092,2.756,2.86,3.329l-.052.364a14.3,14.3,0,0,1-1.436-.068,36.639,36.639,0,0,0-8.151,0,9.153,9.153,0,0,1-1.127.071l-.052-.364c3.276-.832,4.423-2.184,6.189-6.813,2.548-6.68,11.234-29.8,11.234-29.8h.364l9.674,28.189c1.977,5.669,2.6,7.489,5.721,8.426v.364c-1.092,0-1.987-.038-2.811-.115a50.589,50.589,0,0,0-9.461-.052c-1.13.108-2.264.166-3.33.166l-.052-.364c1.768-.572,2.7-1.4,2.7-3.277a12.414,12.414,0,0,0-.676-3.537,5.311,5.311,0,0,0-1.04-.971m-7.906-4.386,7.517.179-3.669-11.1Z",
    transform: "translate(-703.637 -112.775)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M194.456,169.34h-3.123l.961-48.765h1.533Z",
    transform: "translate(-145.371 -91.61)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M190.175,118.413l-2.7-5.11h5.4Z",
    transform: "translate(-142.439 -86.085)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M151.436,129.877a1.8,1.8,0,1,1-1.8-1.8,1.8,1.8,0,0,1,1.8,1.8",
    transform: "translate(-112.32 -97.308)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M172.436,149.877a1.8,1.8,0,1,1-1.8-1.8,1.8,1.8,0,0,1,1.8,1.8",
    transform: "translate(-128.275 -112.504)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M139.677,167a1.922,1.922,0,1,1-1.922-1.922A1.922,1.922,0,0,1,139.677,167",
    transform: "translate(-103.203 -125.42)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 0.522,
    height: 4.292,
    transform: "translate(37.336 33.945) rotate(-10.295)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2",
    "data-name": "Ret\\xE2ngulo 2",
    width: 0.589,
    height: 4.241,
    transform: "matrix(0.997, -0.075, 0.075, 0.997, 42.252, 39.058)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M157.677,190a1.922,1.922,0,1,1-1.922-1.922A1.922,1.922,0,0,1,157.677,190",
    transform: "translate(-116.879 -142.895)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M130.677,145a1.922,1.922,0,1,1-1.922-1.922A1.922,1.922,0,0,1,130.677,145",
    transform: "translate(-96.365 -108.705)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M145.833,165.6s3.723-.6,4.925.6l.843.9s-2.786-1.952-5.658-.823Z",
    transform: "translate(-110.8 -125.705)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M163.1,189.409s3.723-.6,4.925.6l.843.9s-2.786-1.952-5.658-.823Z",
    transform: "translate(-123.917 -143.795)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M136.887,143.341a44.645,44.645,0,0,1,8.275,5.822s5.285,6.967,6.006,9.129l-.24,3.123s-4.084-8.888-5.525-10.33c0,0-5.542-5.877-7.1-6.061Z",
    transform: "translate(-104.004 -108.907)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M235.333,108.377a1.8,1.8,0,1,0,1.8-1.8,1.8,1.8,0,0,0-1.8,1.8",
    transform: "translate(-178.8 -80.973)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M214.333,128.377a1.8,1.8,0,1,0,1.8-1.8,1.8,1.8,0,0,0-1.8,1.8",
    transform: "translate(-162.845 -96.169)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M246.333,145.5a1.922,1.922,0,1,0,1.922-1.922,1.922,1.922,0,0,0-1.922,1.922",
    transform: "translate(-187.158 -109.085)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    width: 4.292,
    height: 0.522,
    transform: "translate(57.033 32.91) rotate(-79.705)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4",
    "data-name": "Ret\\xE2ngulo 4",
    width: 4.241,
    height: 0.589,
    transform: "matrix(0.075, -0.997, 0.997, 0.075, 52.491, 38.079)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M228.333,168.5a1.922,1.922,0,1,0,1.922-1.922,1.922,1.922,0,0,0-1.922,1.922",
    transform: "translate(-173.482 -126.56)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M255.333,123.5a1.922,1.922,0,1,0,1.922-1.922,1.922,1.922,0,0,0-1.922,1.922",
    transform: "translate(-193.996 -92.37)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M234.09,144.1s-3.723-.6-4.925.6l-.843.9s2.786-1.952,5.658-.823Z",
    transform: "translate(-173.474 -109.37)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M216.828,167.909s-3.723-.6-4.925.6l-.843.9s2.786-1.952,5.658-.823Z",
    transform: "translate(-160.358 -127.459)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M216.114,121.841a44.644,44.644,0,0,0-8.275,5.822s-5.285,6.966-6.006,9.129l.24,3.123s4.084-8.888,5.525-10.33c0,0,5.542-5.877,7.1-6.061Z",
    transform: "translate(-153.348 -92.572)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M159.745,36.118l-.045.038a9.656,9.656,0,0,1-2.336.962c-.907.419-2.07.256-3.549.659-2.642.721-2.642,3.363-5.765,4.564a14.792,14.792,0,0,1-12.732,0c-3.123-1.2-2.642-4.084-5.285-4.8a21.156,21.156,0,0,0-3.809-.682,3.291,3.291,0,0,1-1.729-.662c-.142-.108-.275-.215-.393-.315a.387.387,0,0,0-.635.278c-.319,6.124,6.085,13.633,6.085,13.633.721,1.441,6.006,3.123,6.006,3.123a8,8,0,0,1,2.9,1.584,3.438,3.438,0,0,0,1.834.715,13.2,13.2,0,0,0,1.394.039,13.39,13.39,0,0,0,1.64-.061,2.781,2.781,0,0,0,1.455-.59,8.36,8.36,0,0,1,3.031-1.688s5.765-1.441,6.486-2.883c0,0,5.924-7.509,5.6-13.633-.017-.32.091-.484-.154-.278",
    transform: "translate(-93.798 -27.19)",
    fill: "#dd7876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M155.815,3.756a6.467,6.467,0,0,0-1.947-.032c-1.274.163-4.239.3-6.329-1.544A9.071,9.071,0,0,0,141.581,0V0l-.062,0-.062,0V0A9.072,9.072,0,0,0,135.5,2.18c-2.169,1.908-5.278,1.694-6.465,1.526a5.12,5.12,0,0,0-1.287-.021c-4.191.469-4.412,2.82-4.412,2.82a2.023,2.023,0,0,0,1.494,1.8,2.964,2.964,0,0,1,.386.172,10.418,10.418,0,0,0,4.1.9,3.524,3.524,0,0,1,2.023.737,18.99,18.99,0,0,1,2.923,3.116c2.411,2.12,6.367,1.995,7.262,1.936.9.059,4.851.184,7.262-1.936a26.264,26.264,0,0,1,3.089-2.872,4.449,4.449,0,0,1,2.078-.735,11.99,11.99,0,0,0,4.587-1.267l.033-.009a1.735,1.735,0,0,0,.7-2.973,6.8,6.8,0,0,0-3.447-1.619",
    transform: "translate(-93.706)",
    fill: "#dd7876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M160.63,313.785c.014.372.085,2.051.209,3.766-.561-.884-3.513-5.595-4.294-5.2-2.3,1.146-.768,4.763.669,7.06-1.561-1-2.652,2.7,1.841,5.181l-.063.582a14.593,14.593,0,0,0-2.806,3.255,24.39,24.39,0,0,0-5.593,3.816l-1.362-.457c3.095-3.765,4.843-4.955,5.655-6.277.535-.874,1.5-3.489.707-4.775a1.608,1.608,0,0,0-1.648-.644,11.68,11.68,0,0,0-3.315,2.793,8.809,8.809,0,0,0-4.307,3.658c-1.527,1.086-4.488,3.5-5.1,5.319-1.173,3.452-2.98,9.3-1.377,12.6-.176,2.685-.2,7.84.917,10.36,2.009,4.54,14.02,5.9,14.148,5.757s-2.345-8.47-.815-10.914c1.505-2.406,9.2-8.8,9.991-10.1.813-1.31,1.676-10.933,1.493-12.231-.021-.173-.154.314.553-1.795.834-2.486,1.493-3.579.491-5.3-.223-.382,3.238-4.887,1.384-5.509a3,3,0,0,0-3.177,1.053c-.133-.834-1.072-6.835-1.814-7.207-1.027-.515-3.268.009-2.392,5.209",
    transform: "translate(-105.773 -234.33)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M240.9,392.129s.875-2.51,1.726-5.009",
    transform: "translate(-183.029 -294.125)",
    fill: "none",
    stroke: "#d38f7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M228.488,334.94c-1.06-.356-3.041-.076-4.639,3.634a45.655,45.655,0,0,0-3.122,5.794s-.9.751-1.849,1.7",
    transform: "translate(-166.298 -254.392)",
    fill: "none",
    stroke: "#d38f7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M217.371,372.183c.071-.212,5.775-5.966,6.945-7.7.961-1.421.923-4.371,1.468-6.359",
    transform: "translate(-165.153 -272.096)",
    fill: "none",
    stroke: "#d38f7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M230.219,350.606a11.661,11.661,0,0,0,.473,2.972",
    transform: "translate(-174.915 -266.382)",
    fill: "none",
    stroke: "#d38f7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M215.125,354.511l1.9,3.823-.213,1.934",
    transform: "translate(-163.447 -269.349)",
    fill: "none",
    stroke: "#d38f7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    "data-name": "Caminho 33",
    d: "M168.721,408.884s1.774-2.015,3.088-3.6",
    transform: "translate(-128.19 -307.928)",
    fill: "none",
    stroke: "#d38f7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    "data-name": "Caminho 34",
    d: "M597.386,174.729c-.52,4.681-2.808,8.477-7.281,8.477-3.589,0-3.953-2.7-3.953-5.981V170.7c2.811-2.6,6.716-2.34,8.446-2.058a.727.727,0,0,0,.835-.8c-.466-4.281-3.992-4.22-4.527-4.185a.741.741,0,0,0-.128.019,8.956,8.956,0,0,0-4.627,3.463V155.954c0-2.445.416-2.913,4.213-2.913,4.369,0,4.629,2.7,5.617,5.981h.52c.052-2.757.676-6.709.728-9.726h-.416c-2.344,1.01-8.5,1.343-12.028,1.522a27.131,27.131,0,0,1-4.539-.142c-2.044-.239-5.3-.627-7.135-.627l.038.443c3.225.884,4.941,2.861,4.941,8.426v18.307c0,5.565-1.716,7.593-4.941,8.478l1.435.274c2.7,0,6.039.13,7.166.13,2.629,0,9.863.012,11.683.012,4.525,0,3.849-.312,4.369-11.39Z",
    transform: "translate(-435.437 -113.432)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    "data-name": "Caminho 35",
    d: "M597.386,174.729c-.52,4.681-2.808,8.477-7.281,8.477-3.589,0-3.953-2.7-3.953-5.981V170.7c2.811-2.6,6.716-2.34,8.446-2.058a.727.727,0,0,0,.835-.8c-.466-4.281-3.992-4.22-4.527-4.185a.741.741,0,0,0-.128.019,8.956,8.956,0,0,0-4.627,3.463V155.954c0-2.445.416-2.913,4.213-2.913,4.369,0,4.629,2.7,5.617,5.981h.52c.052-2.757.676-6.709.728-9.726h-.416c-2.344,1.01-8.5,1.343-12.028,1.522a27.131,27.131,0,0,1-4.539-.142c-2.044-.239-5.3-.627-7.135-.627l.038.443c3.225.884,4.941,2.861,4.941,8.426v18.307c0,5.565-1.716,7.593-4.941,8.478l1.435.274c2.7,0,6.039.13,7.166.13,2.629,0,9.863.012,11.683.012,4.525,0,3.849-.312,4.369-11.39Z",
    transform: "translate(-435.437 -113.432)",
    fill: "none",
    stroke: "#e8c6ad",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_5",
    "data-name": "Ret\\xE2ngulo 5",
    width: 11.771,
    height: 1.922,
    transform: "translate(203.527 75.188)",
    fill: "#e8c6ad"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PROGRAMA_DE_FIDELIDADE_ELIMACOL",
    "data-name": "PROGRAMA DE FIDELIDADE ELIMACOL",
    transform: "translate(83 94)",
    fill: "#e8c6ad",
    fontSize: 8,
    fontFamily: "Belda-ExtMed, Belda Ext"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "0.058em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.048em"
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.058em"
  }, "OGR"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.057em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.058em"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.016em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.058em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.042em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.058em"
  }, "E FI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.043em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.058em"
  }, "ELI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.025em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.058em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.043em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "E ELIMACOL")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3547a06fc8e403a32de69d7677194f5d.svg";
export { ForwardRef as ReactComponent };